import { UserDto } from '../../model/user/user-dto';

export interface HomeStateModel {
  userDetails: UserDto | null;
}

export class HomeAction {
  static readonly type = '[Auth] Login';

  constructor(public id: string) {
  }
}

export class UserDetail {
  static readonly type = '[Auth] UserDetail';

  constructor(public payload: UserDto) {
  }
}
